import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { ApiPageResponse, PageQuery } from '../types/api.types';
import { Transaction } from '../types/transaction.types';

@Injectable({ providedIn: 'root' })
export class TransactionsService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.gatewayUrl}/payment/api/transactions`;

  /**
   * Admin paginated list. NOTE: payment-service doesn't wrap in `ApiCollection`,
   * so `status` / `message` are absent — `ApiPageResponse` makes them optional.
   */
  list(query: PageQuery = {}): Observable<ApiPageResponse<Transaction>> {
    return this.http.get<ApiPageResponse<Transaction>>(this.base, {
      params: this.pageParams(query),
    });
  }

  get(id: number): Observable<Transaction> {
    return this.http.get<Transaction>(`${this.base}/${id}`);
  }

  /** Lookup transactions emitted from a specific source entity (cross-service). */
  bySource(sourceService: string, sourceEntityId: string): Observable<Transaction[]> {
    const params = new HttpParams()
      .set('sourceService', sourceService)
      .set('sourceEntityId', sourceEntityId);
    return this.http.get<Transaction[]>(`${this.base}/by-source`, { params });
  }

  private pageParams(query: PageQuery): HttpParams {
    let params = new HttpParams()
      .set('pageable', 'true')
      .set('page', String(query.page ?? 1))
      .set('size', String(query.size ?? 10))
      .set('isDeleted', String(query.isDeleted ?? false));
    if (query.search?.trim()) params = params.set('search', query.search.trim());
    return params;
  }
}
